'use strict';


var Panel        = require('mag-component-panel'),
    LayoutList   = require('mag-component-layout-list'),

    //footer      = require('./footer'),
    exitConfirm = require('../widgets/exit.confirm'),
    mainPanel   = require('./main.panel'),

    panel        = new Panel({
        title: gettext('Menu'),
        children: [],
        className: 'leftPanel'
    }),
    list = new LayoutList({
        cycle: true,
        focusIndex: 0,
        size: 3,
        events: {
            focus: function () {
                // show footer if list have at least one item
                //footer.init();
            },
            blur: function () {
                //footer.init();
            }
        }
    }),
    $searchIcon = null,
    $searchText = null,
    menuData;


menuData = [
    {
        items: [
            {
                className: 'theme-icon theme-icon-search',
                value: ''
            },
            {
                value: gettext('Search')
            }
        ],
        click: function ( $item ) {
            $searchIcon = $item.firstChild.firstChild;
            $searchText = $item.firstChild.lastChild;

            core.intent({
                action: 'keyboard',
                data: {
                    title: 'Enter query',
                    value: $item.lastChild.lastChild.innerText === gettext('Search') ? '' : $item.lastChild.lastChild.innerText
                },
                events: {
                    done: function ( event ) {
                        // var mainPanel = require('./main.panel');
                        // if ( mainPanel === null ) {
                        //     mainPanel = require('./main.panel')
                        // }

                        mainPanel.filterContent({
                            name: event.value
                        });
                        panel.setSearchQuery(event.value);
                    }
                }
            }, function ( error ) {
                console.log(error);
            });
        }
    },
    {
        items: [
            {
                className: 'theme-icon theme-icon-toggle'
            },
            {
                value: gettext('Advanced')
            }
        ],
        click: function ( event )  {
            // var mainPanel = require('./main.panel');

            if ( this.advanced ) {
                event.layout.$body.children[0].className = 'theme-icon theme-icon-toggle';
            } else {
                event.layout.$body.children[0].className = 'theme-icon theme-icon-toggle-active active';
            }
            this.advanced = !this.advanced;

            mainPanel.filterContent({
                advanced: this.advanced
            });
        }
    },
    {
        items: [
            {
                className: 'theme-icon theme-icon-exit'
            },
            {
                value: gettext('Exit')
            }
        ],
        click: function () {
            exitConfirm.show(list);
        }
    }
];


if ( PLATFORM !== 'MAG' ) {
    menuData.splice(1, 1);
}

list.setData({
    data: menuData,
    focusIndex: 0
});


panel.setSearchQuery = function ( query ) {
    if ( $searchIcon !== null ) {
        // already initialzed
        if ( query ) {
            $searchIcon.classList.add('active');
            $searchText.innerText = query;
        } else {
            $searchIcon.classList.remove('active');
            $searchText.innerText = gettext('Search');
        }
    }
};

panel.add(list);

module.exports = panel;
